import { render, staticRenderFns } from "./news-detail.vue?vue&type=template&id=35ab909a&scoped=true&"
import script from "./news-detail.vue?vue&type=script&lang=js&"
export * from "./news-detail.vue?vue&type=script&lang=js&"
import style0 from "./news-detail.vue?vue&type=style&index=0&id=35ab909a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab909a",
  null
  
)

export default component.exports